import { Entity } from '@sketchpixy/rubix/lib/L20n';
import _ from 'lodash';
import React from 'react';
import { connect } from 'react-redux';
import { initialize, submit } from 'redux-form';
import CustomTableFields from '../../components/CustomTables/CustomTableFields.jsx';
import CustomTableView from '../../components/CustomTables/CustomTableView.jsx';
import CustomTableForm from '../../components/forms/CustomTables/CustomTableForm.jsx';
import CustomTableFieldForm from '../../components/forms/CustomTables/CustomTableFieldForm.jsx';
import MDButton from '../../components/MDButton/MDButton.jsx';
import OperationalView from '../../components/OperationalView/OperationalView.jsx';
import PresentationalViewHeader from '../../components/PresentationalView/PresentationalViewHeader.jsx';
import * as CustomTablesActions from '../../redux/actions/customTables.actions';
import * as ModalActions from '../../redux/actions/modal.actions';
import * as UtilsActions from '../../redux/actions/utils.actions';
import FormFlatContainer from '../../components/forms/Elements/FormFlatContainer.jsx';
import CustomTableDeleteView from '../../components/CustomTables/CustomTableDeleteView.jsx';

let filterTimeout;

@connect(state => ({
  form: state.form.CustomTableForm,
  formField: state.form.CustomTableFieldForm,
  customTables: state.customTables,
  routing: state.router,
  viewLoading: state.utils.viewLoading,
  themeName: state.settings.items.theme.data.themeName,
  customTableLimits: state.customTables.customTableLimits,
}))
class CustomTables extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isFieldOperationalMode: false,
      selectedField: null
    };
  }

  componentWillMount() {
    this.onFetchCustomTables();
  }

  componentWillUnmount() {
    const { dispatch } = this.props;
    dispatch(CustomTablesActions.setSelectedCustomTable({}));
    dispatch(CustomTablesActions.setCustomTablesOperationalMode(false));
  }

  async onFetchCustomTables() {
    const { dispatch } = this.props;
    dispatch(UtilsActions.setViewLoading(true));
    try {
      await dispatch(CustomTablesActions.fetchCustomTablesWithDetails());
    } finally {
      dispatch(UtilsActions.setViewLoading(false));
    }
  }

  onNewCustomTableButtonClicked() {
    const { dispatch, customTableLimits, customTables: { data: { pagination } } } = this.props;
    const numberOfCustomTables = pagination && pagination.totalElements ? pagination.totalElements : 0;
    
    // Check custom table limit
    if (customTableLimits && customTableLimits.maxTableNumber !== -1 && numberOfCustomTables >= customTableLimits.maxTableNumber) {
      dispatch(ModalActions.showModal({
        modalType: 'ERROR_MODAL',
        modalProps: {
          type: 'DEFAULT_ERROR',
          defaultMessage: <Entity entity="customTableLimitReachedUpgrade" />,
        },
      }));
      return;
    }
    
    dispatch(CustomTablesActions.setSelectedCustomTable({}));
    dispatch(initialize('CustomTableForm', {}));
    dispatch(CustomTablesActions.setCustomTablesOperationalMode(true));
  }

  onCloseOperationalSection() {
    const { dispatch } = this.props;
    dispatch(CustomTablesActions.setSelectedCustomTable({}));
    dispatch(CustomTablesActions.setCustomTablesOperationalMode(false));
  }

  onSetFilter(field, value) {
    const { dispatch } = this.props;
    dispatch(CustomTablesActions.setCustomTablesFilter(field, value));
    if (filterTimeout) clearTimeout(filterTimeout);
    filterTimeout = setTimeout(async () => {
      await this.onFetchCustomTables();
    }, 500);
  }

  onSearchReset() {
    const { dispatch } = this.props;
    dispatch(CustomTablesActions.resetCustomTablesFilters());
    this.onFetchCustomTables();
  }

  async onSelectCustomTable(customTable) {
    const { dispatch } = this.props;
    try {
      dispatch(UtilsActions.setSpinnerVisibile(true));
      const customTableDetails = await dispatch(CustomTablesActions.getCustomTableDetails(customTable.id));
      dispatch(CustomTablesActions.setSelectedCustomTable(customTableDetails));
      dispatch(initialize('CustomTableForm', customTable));
      dispatch(CustomTablesActions.setCustomTablesOperationalMode(true));
      dispatch(UtilsActions.setSpinnerVisibile(false));
    } catch (error) {
      dispatch(CustomTablesActions.setSelectedCustomTable({}));
      dispatch(UtilsActions.setSpinnerVisibile(false));
    }
  }

  onDeleteCustomTable(customTableId) {
    const { dispatch } = this.props;
    const params = {
      modalType: 'CONTENT_MODAL',
      modalProps: {
        title: <Entity entity="deleteSubscriptionRequest" />,
        content: <CustomTableDeleteView onDeleteConfirm={() => this.onDeleteCustomTableConfirmed(customTableId)} />,
        modalStyle: { height: '90% !important' },
        onOutsideClick: () => dispatch(ModalActions.hideModal()),
      },
    };
    dispatch(ModalActions.showModal(params));
  }

  async onDeleteCustomTableConfirmed(customTableId) {
    const { dispatch } = this.props;
    dispatch(UtilsActions.setSpinnerVisibile(true));
    try {
      await dispatch(CustomTablesActions.deleteCustomTable(customTableId));
      dispatch(UtilsActions.setSpinnerVisibile(false));
      dispatch(CustomTablesActions.setCustomTablesOperationalMode(false));
      this.onFetchCustomTables();
      dispatch(ModalActions.showModal({
        modalType: 'SUCCESS_ALERT',
        modalProps: {
          message: (<h6 className="snack-title"><Entity entity="customTableDeleteSuccess" /></h6>),
        },
      }));
    } catch (error) {
      dispatch(UtilsActions.setSpinnerVisibile(false));
      dispatch(CustomTablesActions.setCustomTablesOperationalMode(false));
      dispatch(ModalActions.showModal({
        modalType: 'ERROR_ALERT',
        modalProps: {
          message: (<h6 className="snack-title"><Entity entity="customTableDeleteError" /></h6>),
        },
      }));
      this.onFetchCustomTables();
    }
  }

  async onCreateNewCustomTable(customTableData) {
    const { dispatch } = this.props;
    try {
      dispatch(UtilsActions.setSpinnerVisibile(true));
      const customTable = await dispatch(CustomTablesActions.createCustomTable(customTableData));
      dispatch(CustomTablesActions.setCustomTablesOperationalMode(false));
      dispatch(UtilsActions.setSpinnerVisibile(false));
      this.onFetchCustomTables();
      dispatch(CustomTablesActions.setSelectedCustomTable(customTable));
      dispatch(ModalActions.showModal({
        modalType: 'SUCCESS_ALERT',
        modalProps: {
          message: (<h6 className="snack-title"><Entity entity="customTableCreatedSuccessFully" /></h6>),
        },
      }));
    } catch (error) {
      dispatch(UtilsActions.setSpinnerVisibile(false));
      dispatch(ModalActions.showModal({
        modalType: 'ERROR_ALERT',
        modalProps: {
          message: (<h6 className="snack-title"><Entity entity="customTableActionError" /></h6>),
        },
      }));
    }
  }

  async onEditCustomTable(customTableData) {
    const { dispatch } = this.props;
    try {
      dispatch(UtilsActions.setSpinnerVisibile(true));
      await dispatch(CustomTablesActions.updateCustomTable(customTableData.id, customTableData));
      dispatch(UtilsActions.setSpinnerVisibile(false));
      this.onFetchCustomTables();
      dispatch(CustomTablesActions.setCustomTablesOperationalMode(false));
      dispatch(CustomTablesActions.setSelectedCustomTable({}));
      dispatch(ModalActions.showModal({
        modalType: 'SUCCESS_ALERT',
        modalProps: {
          message: (<h6 className="snack-title"><Entity entity="customTableUpdatedSuccessFully" /></h6>),
        },
      }));
    } catch (error) {
      dispatch(UtilsActions.setSpinnerVisibile(false));
      dispatch(ModalActions.showModal({
        modalType: 'ERROR_ALERT',
        modalProps: {
          message: (<h6 className="snack-title"><Entity entity="customTableActionError" /></h6>),
        },
      }));
    }
  }

  onCustomTableFormSubmit(customTableData) {
    if (customTableData && customTableData.id) {
      this.onEditCustomTable(customTableData);
    } else {
      this.onCreateNewCustomTable(customTableData);
    }
  }

  onFetchCustomTablesOnPage(page) {
    const { dispatch } = this.props;
    dispatch(CustomTablesActions.fetchCustomTablesWithDetails(page));
  }

  onEditTableField(field) {
    const { dispatch } = this.props;
    this.setState({ 
      isFieldOperationalMode: true,
      selectedField: field 
    });
    dispatch(initialize('CustomTableFieldForm', field));
  }

  onDeleteTableField(field) {
    const { dispatch } = this.props;
    const params = {
      modalType: 'CONFIRM_TO_CONTINUE_MODAL',
      modalProps: {
        title: 'confirmBeforeContinue',
        body: <Entity entity="deleteCustomTableFieldConfirm" />,
        onConfirmText: <Entity entity="yes" />,
        onConfirm: () => this.onDeleteTableFieldConfirmed(field),
        onCancelText: <Entity entity="no" />,
        onCancel: () => dispatch(ModalActions.hideModal()),
      },
    };
    dispatch(ModalActions.showModal(params));
  }

  async onDeleteTableFieldConfirmed(field) {
    const { dispatch, customTables: { selectedCustomTable } } = this.props;
    dispatch(UtilsActions.setSpinnerVisibile(true));
    try {
      await dispatch(CustomTablesActions.deleteCustomTableField(selectedCustomTable.id, field.id));
      dispatch(UtilsActions.setSpinnerVisibile(false));
      const updatedCustomTable = await dispatch(CustomTablesActions.getCustomTableDetails(selectedCustomTable.id));
      dispatch(CustomTablesActions.setSelectedCustomTable(updatedCustomTable));
      dispatch(ModalActions.showModal({
        modalType: 'SUCCESS_ALERT',
        modalProps: {
          message: (<h6 className="snack-title"><Entity entity="customTableFieldDeletedSuccessFully" /></h6>),
        },
      }));
    } catch (error) {
      dispatch(UtilsActions.setSpinnerVisibile(false));
      dispatch(ModalActions.showModal({
        modalType: 'ERROR_ALERT',
        modalProps: {
          message: (<h6 className="snack-title"><Entity entity="customTableFieldActionError" /></h6>),
        },
      }));
    }
  }

  onAddTableField() {
    this.setState({ 
      isFieldOperationalMode: true,
      selectedField: null 
    });
    this.props.dispatch(initialize('CustomTableFieldForm', { isSearchField: false }));
  }

  onCloseFieldOperationalSection() {
    this.setState({ 
      isFieldOperationalMode: false,
      selectedField: null 
    });
  }

  async onCustomTableFieldFormSubmit(fieldData) {
    const { dispatch, customTables: { selectedCustomTable } } = this.props;
    try {
      dispatch(UtilsActions.setSpinnerVisibile(true));
      if (this.state.selectedField) {
        // Update existing field
        await dispatch(CustomTablesActions.updateCustomTableField(selectedCustomTable.id, fieldData.id, fieldData));
      } else {
        // Create new field
        await dispatch(CustomTablesActions.createCustomTableField(selectedCustomTable.id, fieldData));
      }
      const updatedCustomTable = await dispatch(CustomTablesActions.getCustomTableDetails(selectedCustomTable.id));
      dispatch(CustomTablesActions.setSelectedCustomTable(updatedCustomTable));
      dispatch(UtilsActions.setSpinnerVisibile(false));
      this.setState({ isFieldOperationalMode: false });
      dispatch(ModalActions.showModal({
        modalType: 'SUCCESS_ALERT',
        modalProps: {
          message: (<h6 className="snack-title"><Entity entity={this.state.selectedField ? "customTableFieldUpdatedSuccessFully" : "customTableFieldCreatedSuccessFully"} /></h6>),
        },
      }));
    } catch (error) {
      dispatch(UtilsActions.setSpinnerVisibile(false));
      dispatch(ModalActions.showModal({
        modalType: 'ERROR_ALERT',
        modalProps: {
          message: (<h6 className="snack-title"><Entity entity="customTableFieldActionError" /></h6>),
        },
      }));
    }
  }

  render() {
    const { customTables: { isOperationalMode, selectedCustomTable, data: { pagination } }, form, formField, themeName, dispatch, viewLoading, customTableLimits } = this.props;
    const { isFieldOperationalMode, selectedField } = this.state;
    const numberOfCustomTables = pagination && pagination.totalElements ? pagination.totalElements : 0;
    const canCreateItem = true;

    return (
      <div>
        <PresentationalViewHeader
          themeName={themeName}
          onFilterChange={value => this.onSetFilter('name', _.trim(value))}
          onNewEntity={canCreateItem ? () => this.onNewCustomTableButtonClicked() : null}
          onSearchSubmit={() => this.onFetchCustomTables()}
          onSearchReset={() => this.onSearchReset()}
          searchGuestContainerStyle={{ width: 280 }}
          newEntityTitle="createNewCustomTable"
          searchPlaceholderEntityName="customTableName"
          newEntityIconName="icon-simple-line-icons-grid"
          isLoading={viewLoading}
          numberOfElements={numberOfCustomTables}
        />
        <CustomTableView
          customTable={selectedCustomTable}
          canCreateItem={canCreateItem}
          onNewCustomTable={() => this.onNewCustomTableButtonClicked()}
          onSelectCustomTable={customTable => this.onSelectCustomTable(customTable)}
          onRefreshCustomTables={() => this.onFetchCustomTables()}
          onFetchCustomTablesOnPage={page => this.onFetchCustomTablesOnPage(page)}
          onDeleteCustomTable={customTableId => this.onDeleteCustomTable(customTableId)}
        />
        <OperationalView
          themeName={themeName}
          isVisible={isOperationalMode}
          onClose={() => this.onCloseOperationalSection()}
          title={<Entity entity={(selectedCustomTable && selectedCustomTable.name) || "customTableOperationalTitle"} key={(selectedCustomTable?.name || '')} />}
          onDelete={selectedCustomTable && selectedCustomTable.id ? () => this.onDeleteCustomTable(selectedCustomTable.id) : null}
        >
          <div style={{ paddingBottom: '10%' }}>
            <CustomTableForm
              onSubmit={customTableData => this.onCustomTableFormSubmit(customTableData)}
            />
            {selectedCustomTable && selectedCustomTable.id ? (
              <FormFlatContainer title="tableFields">
                <CustomTableFields
                  onAddField={() => this.onAddTableField()}
                  onEditField={(field) => this.onEditTableField(field)}
                  onDeleteField={(field) => this.onDeleteTableField(field)}
              />
              </FormFlatContainer>
            ) : null}
            <MDButton
              title={<Entity entity="save" />}
              containerStyle={{ position: 'absolute', left: 0, right: 0, bottom: 0, width: '100%', margin: 0 }}
              style={{ height: 45, borderRadius: 0 }}
              onClick={() => dispatch(submit('CustomTableForm'))}
            />
          </div>
        </OperationalView>
        <OperationalView
          themeName={themeName}
          isVisible={isFieldOperationalMode}
          onClose={() => this.onCloseFieldOperationalSection()}
          title={<Entity entity={selectedField ? "editCustomTableField" : "addCustomTableField"} />}
        >
          <div style={{ paddingBottom: '10%' }}>
            <CustomTableFieldForm
              formValues={formField && formField.values ? formField.values : {}}
              onSubmit={fieldData => this.onCustomTableFieldFormSubmit(fieldData)}
              availableCustomTables={this.props.customTables.data.items}
            />
            <MDButton
              title={<Entity entity="save" />}
              containerStyle={{ position: 'absolute', left: 0, right: 0, bottom: 0, width: '100%', margin: 0 }}
              style={{ height: 45, borderRadius: 0 }}
              onClick={() => dispatch(submit('CustomTableFieldForm'))}
            />
          </div>
        </OperationalView>
      </div>
    );
  }
}

export default CustomTables; 